import type { Sha256 } from './hash.types';

/**
 * Calculates the SHA-256 hash of the given data using the browser's built-in crypto API.
 *
 * @param data - The data to be hashed.
 * @returns A promise that resolves to the hexadecimal representation of the SHA-256 hash.
 */
export const sha256: Sha256 = async (data: Uint8Array): Promise<string> => {
  const hash = await window.crypto.subtle.digest('SHA-256', data);
  return bufferToHex(hash);
};

/**
 * Converts an ArrayBuffer to a hexadecimal string representation.
 *
 * @param buffer - The ArrayBuffer to convert.
 * @returns The hexadecimal string representation of the buffer.
 */
function bufferToHex(buffer: ArrayBuffer): string {
  return Array.from(new Uint8Array(buffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}
